import { useEffect, useRef, useState } from "react";
import { I, IC, MAIS_CATEGORIAS } from "../constants/nav";
import "./mobileNavigation.css";

const descriptions = {
  pedidos:"Do pedido à entrega", caixa:"Vendas no balcão", site:"Vitrine e pedidos online", clientes:"Contatos e histórico",
  fila:"Organize a produção", filamentos:"Rolos, cores e consumo", materiais:"Insumos e estoque", financeiro:"Entradas e saídas", config:"Empresa e preferências",
  parceiros:"Peças em consignação",
};
const normalize = text => text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export function MobileMore({ tab, onGoTab, onClose, onLogout, isFavorito, toggleFavorito, clientesBadge, consignacaoAtiva = false }) {
  const [search, setSearch] = useState("");
  const closeRef = useRef(null);
  const closeAction = useRef(onClose);
  useEffect(() => { closeAction.current = onClose; }, [onClose]);
  const groups = MAIS_CATEGORIAS.map(group => ({ ...group, itens:group.itens.filter(item => (consignacaoAtiva || item.id !== "parceiros") && normalize(`${item.label} ${descriptions[item.id]}`).includes(normalize(search.trim()))) })).filter(group => group.itens.length);
  useEffect(() => {
    const previous = document.activeElement;
    closeRef.current?.focus();
    const key = e => {
      if (document.querySelector(".tour-layer")) return;
      if (e.key === "Escape") closeAction.current();
      if (e.key === "Tab") {
        const buttons = [...document.querySelectorAll('.mobile-more button, .mobile-more input')].filter(el => !el.disabled);
        const first = buttons[0], last = buttons[buttons.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
      }
    };
    window.addEventListener("keydown", key);
    return () => { window.removeEventListener("keydown", key); previous?.isConnected && previous.focus(); };
  }, []);
  return <div className="mobile-more-backdrop" onClick={onClose}>
    <section className="mobile-more" role="dialog" aria-modal="true" aria-labelledby="mobile-more-title" onClick={e => e.stopPropagation()}>
      <header className="mobile-more-header">
        <div><span className="mobile-eyebrow">SEU ESPAÇO DE TRABALHO</span><h2 id="mobile-more-title">Explore o app</h2></div>
        <button type="button" ref={closeRef} className="mobile-icon-button" aria-label="Fechar Mais" onClick={onClose}>✕</button>
      </header>
      <div className="mobile-more-search"><I d={IC.dots} s={18} /><input aria-label="Buscar ferramentas" placeholder="Buscar uma ferramenta…" value={search} onChange={e => setSearch(e.target.value)} /></div>
      <div className="mobile-more-content">
        <p className="mobile-more-hint">Toque na estrela para fixar um atalho no Início.</p>
        {groups.map(group => <section key={group.id} className={`mobile-more-group mobile-group-${group.id}`} aria-label={group.label}>
          <h3>{group.label}<span>{group.itens.length}</span></h3>
          <div className="mobile-more-grid">{group.itens.map(item => <div className={`mobile-tool${tab === item.id ? " is-active" : ""}`} key={item.id}>
            <button type="button" className="mobile-tool-open" data-tour={`nav-${item.id}`} aria-current={tab === item.id ? "page" : undefined} onClick={() => onGoTab(item.id)}>
              <span className="mobile-tool-icon"><I d={item.icon} s={21} />{item.badge && clientesBadge > 0 && <span className="mobile-tool-badge" aria-label={`${clientesBadge} novidades`}>{clientesBadge}</span>}</span>
              <strong>{item.label}</strong><small>{descriptions[item.id]}</small>
            </button>
            <button type="button" className="mobile-tool-favorite" aria-label={`${isFavorito(item.id) ? "Desafixar" : "Fixar"} ${item.label} no Início`} aria-pressed={isFavorito(item.id)} onClick={() => toggleFavorito(item.id)}>★</button>
          </div>)}</div>
        </section>)}
        {!groups.length && <p className="mobile-more-empty" role="status">Nenhuma ferramenta encontrada. Tente outro nome.</p>}
        <button type="button" className="mobile-logout" onClick={onLogout}><I d={IC.logout} s={18} />Sair da conta</button>
      </div>
    </section>
  </div>;
}
